import {
    IUpdateFormValueActionPayload,
    IWithControlName,
    IUpdateFormControllersToRepeatableControllerPayload,
    IActionWithPayload,
    // ICalculatorValues,
    IWithFormName,
    IAppStateControlProperty,
} from '../types';
import {
    UPDATE_FORM_CONTROLLER_VALUE,
    ADD_FORM_CONTROLLERS_TO_REPEATABLE_CONTROLLER,
    UPDATE_FORM_CONTROLLERS_IN_REPEATABLE_CONTROLLER,
    VALIDATE_FORM_DATA,
    SET_FORM_ERRORS,
    // SET_CALCULATOR_VALUES,
    FORM_INITIATED,
    PREPARE_FORM_DATA_IF_VALID,
    RESET_FORM_DATA_VALUES,
    UPDATE_CONTROL_STATE,
    SET_FORM_STEP,
    MERGE_FORM_STATE,
    CREATE_FORM_STATE_SNAPSHOT,
    VALIDATE_LENDER_AMOUNTS,
    UPDATE_PROGRESS,
} from '../constants/actionTypes';
import { IValidationError } from '../types/IValidationError';
import { IFormSettings, IFormControl } from '../types/IFormSettings';

export const initFormAction = (payload: IFormSettings): IActionWithPayload<IFormSettings> => ({
    type: FORM_INITIATED,
    payload,
});

export const updateFormControlValueAction = (
    payload: IUpdateFormValueActionPayload,
): IActionWithPayload<IUpdateFormValueActionPayload> => ({
    type: UPDATE_FORM_CONTROLLER_VALUE,
    payload,
});

export const updateControlState = (
    payload: Partial<IFormControl> & IWithControlName,
): IActionWithPayload<Partial<IFormControl> & IWithControlName> => ({
    type: UPDATE_CONTROL_STATE,
    payload,
});

export const addFormControllersToRepeatableControllerAction = (
    payload: IWithControlName,
): IActionWithPayload<IWithControlName> => ({
    type: ADD_FORM_CONTROLLERS_TO_REPEATABLE_CONTROLLER,
    payload,
});

export const updateFormControllersToRepeatableControllerAction = (
    payload: IUpdateFormControllersToRepeatableControllerPayload,
): IActionWithPayload<IUpdateFormControllersToRepeatableControllerPayload> => ({
    type: UPDATE_FORM_CONTROLLERS_IN_REPEATABLE_CONTROLLER,
    payload,
});

export const validateLenderAmountsAction = (formName: string): IActionWithPayload<IWithFormName> => ({
    type: VALIDATE_LENDER_AMOUNTS,
    payload: { formName },
});

export const validateFormDataAction = (formName: string): IActionWithPayload<IWithFormName> => ({
    type: VALIDATE_FORM_DATA,
    payload: { formName },
});

export const prepareFormDataIfValidAction = (
    formName: string,
): IActionWithPayload<IWithFormName> => ({
    type: PREPARE_FORM_DATA_IF_VALID,
    payload: { formName },
});

export const resetFormDataValues = (formName: string): IActionWithPayload<IWithFormName> => ({
    type: RESET_FORM_DATA_VALUES,
    payload: { formName },
});

export const setFormDataErrors = (
    payload: IValidationError & IWithFormName,
): IActionWithPayload<IValidationError & IWithFormName> => ({
    type: SET_FORM_ERRORS,
    payload,
});

// export const setCalculatorValues = (
//     payload: ICalculatorValues,
// ): IActionWithPayload<ICalculatorValues> => ({
//     type: SET_CALCULATOR_VALUES,
//     payload,
// });

export const setFormStepAction = (
    formName: string,
    value: number,
): IActionWithPayload<IWithFormName & { value: number }> => ({
    type: SET_FORM_STEP,
    payload: {
        formName,
        value,
    },
});

export const mergeFormStateAction = (
    formName: string,
    controlsState: IAppStateControlProperty,
    step: number,
): IActionWithPayload<
    IWithFormName & { controlsState: IAppStateControlProperty; step: number }
> => ({
    type: MERGE_FORM_STATE,
    payload: {
        formName,
        controlsState,
        step,
    },
});

export const createFormStateSnapshotAction = (
    formName: string,
): IActionWithPayload<IWithFormName> => ({
    type: CREATE_FORM_STATE_SNAPSHOT,
    payload: {
        formName,
    },
});

export const calculateProgressAction = (formName: string): IActionWithPayload<IWithFormName> => ({
    type: UPDATE_PROGRESS,
    payload: { formName },
});
